module.exports = __webpack_public_path__ + "static/BANDOFORBICIDORO-5a485caa508dfee4e676b664402a9443.pdf";